// extracted by mini-css-extract-plugin
export default {"notifications":"NotificationProvider_notifications__Xa+UH"};